import { render, staticRenderFns } from "./SelectUsers.vue?vue&type=template&id=0711cdc0&scoped=true"
import script from "./SelectUsers.vue?vue&type=script&lang=js"
export * from "./SelectUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0711cdc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0711cdc0')) {
      api.createRecord('0711cdc0', component.options)
    } else {
      api.reload('0711cdc0', component.options)
    }
    module.hot.accept("./SelectUsers.vue?vue&type=template&id=0711cdc0&scoped=true", function () {
      api.rerender('0711cdc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/overlay/SelectUsers.vue"
export default component.exports